<template>
  <div style="margin-top: 15px; padding-left: 15px" class="card row no-gutter">
    <div class="col-sm-12">
      <div class="col-sm-6">
        <div class="card-header bg-navyblue">
          <strong>Non Attendance Reasons</strong>
        </div>
        <p class="description-header">Set the reasons yo use and track booking against for non-arrivals.
        </p>
        <div class="card-block bg-white">
          <h5 style="margin: 0 0 20px; font-weight: bold;">Reasons</h5>
          <div v-if="value.estimatesBooking.scheduling.reasons.length" class="estimage-line"></div>
          <div v-for="(reason, ind) in value.estimatesBooking.scheduling.reasons" :key="ind" class="form-group row no-gutter" style="margin-top: 15px">
            <div class="col-sm-10">
              <input
                  :readonly="!isStatusActive"
                  type="text"
                  v-model="value.estimatesBooking.scheduling.reasons[ind]"
                  class="form-control">
            </div>
            <div  class="col-sm-2">
              <div style="padding: 5px 20px 0">
                <button @click="value.estimatesBooking.scheduling.reasons.splice(ind, 1)" class="bx-trash-reasons-item"></button>
              </div>
            </div>
          </div>
          <button @click="value.estimatesBooking.scheduling.reasons.push('')" class="btn btn-primary add-status-button float-right">+Add Reason</button>
          <div v-if="value.estimatesBooking.scheduling.reasons.length" class="estimage-line" style="margin-top: 70px"></div>
        </div>
      </div>
      <div class="col-sm-6 pl-1">
        <div class="card-header bg-navyblue">
          <strong>Call Back Attempts</strong>
        </div>
        <p class="description-header">Set the call attempts to choose and track against non-arrivals.
        </p>
        <div class="card-block bg-white">
          <h5 style="margin: 0 0 20px; font-weight: bold;">Attempts</h5>
          <div v-if="value.estimatesBooking.scheduling.attempts.length" class="estimage-line"></div>
          <div v-for="(attempt, ind) in value.estimatesBooking.scheduling.attempts" :key="ind" class="form-group row no-gutter" style="margin-top: 15px">
            <div class="col-sm-10">
              <input
                  :readonly="!isStatusActive"
                  type="text"
                  v-model="value.estimatesBooking.scheduling.attempts[ind]"
                  class="form-control">
            </div>
            <div  class="col-sm-2">
              <div style="padding: 5px 20px 0">
                <button @click="value.estimatesBooking.scheduling.attempts.splice(ind, 1)" class="bx-trash-reasons-item"></button>
              </div>
            </div>
          </div>

          <button @click="value.estimatesBooking.scheduling.attempts.push('')" class="btn btn-primary add-status-button float-right">+Add Another</button>
          <div v-if="value.estimatesBooking.scheduling.attempts.length" class="estimage-line" style="margin-top: 70px"></div>
        </div>
      </div>
    </div>
    <div class="col-sm-12">
      <div class="col-sm-6" style="margin-top: 50px">
        <div class="card-header bg-navyblue">
          <strong>Non Attendance File Status</strong>
        </div>
        <p class="description-header">Set the File Status result to action when Attended Estimate Booking is set.
        </p>
        <div class="card-block bg-white">
          <div class="form-group row no-gutter">
            <label class="col-sm-5 col-form-label">
              File Status for Non-Attendance
            </label>
            <div class="col-sm-7">
              <multiselect
                  :options="value.triggers"
                  v-model="computedCardStatus"
                  :showLabels="false"
                  :option-height="29"
                  :max-height="203"
                  placeholder="Select"
                  :close-on-select="true"
                  track-by="statusId"
                  label="name"
                  style="z-index: 3"
              ></multiselect>
            </div>
          </div>
          <div class="form-group row no-gutter" style="margin-top: 20px">
            <label class="col-sm-5 col-form-label">
              Automatically Add to Status
              <p class="description-text">Set the change in status to be <br>
                automated to the Status referenced <br> above when the vihicle does not <br>
                attend the booking.</p>
            </label>
            <toggle-button
                id="auto-save-button"
                class="mb-0 rs-toggle__button"
                color="#5E79FF"
                :disabled="!isStatusActive"
                v-model="value.estimatesBooking.scheduling.autoAddToStatus"
                :sync="true"
                :width="40"
                :labels="false"/>
            <span class="form-text text-active d-inline-block col-form-label mt-0 ml-0-25">
              <template v-if="value.estimatesBooking.scheduling.autoAddToStatus">Active</template>
              <template v-else>Not Active</template>
            </span>
          </div>
        </div>
      </div>
      <div class="col-sm-6 pl-1" style="margin-top: 50px">
        <div class="card-header bg-navyblue">
          <strong>On Site Estimate Booking File Status</strong>
        </div>
        <p class="description-header">Set the File Status result to action when On-Site Estimate Booking is set.
        </p>
        <div class="card-block bg-white">
          <div class="form-group row no-gutter">
            <label class="col-sm-5 col-form-label">
              File Status for Estimate Booking
            </label>
            <div class="col-sm-7">
              <multiselect
                  :options="value.triggers"
                  v-model="computedOnSiteCardStatus"
                  :showLabels="false"
                  :option-height="29"
                  :max-height="203"
                  placeholder="Select"
                  :close-on-select="true"
                  track-by="statusId"
                  label="name"
                  style="z-index: 3"
              ></multiselect>
            </div>
          </div>
          <div class="form-group row no-gutter" style="margin-top: 20px">
            <label class="col-sm-5 col-form-label">
              Automatically Add to Status
              <p class="description-text">Set the change in status to be <br>
                automated to the Status referenced <br> above when booking date is set.</p>
            </label>
            <toggle-button
                id="auto-save-button"
                class="mb-0 rs-toggle__button"
                color="#5E79FF"
                :disabled="!isStatusActive"
                v-model="value.estimatesBooking.scheduling.onSiteAutoAddToStatus"
                :sync="true"
                :width="40"
                :labels="false"/>
            <span class="form-text text-active d-inline-block col-form-label mt-0 ml-0-25">
              <template v-if="value.estimatesBooking.scheduling.onSiteAutoAddToStatus">Active</template>
              <template v-else>Not Active</template>
            </span>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Multiselect from "vue-multiselect";
import {mapGetters} from "vuex";
import _ from "lodash";
export default {
  name: "scheduling",
  props: {
    value: {}
  },
  components: {
    Multiselect
  },
  computed: {
    ...mapGetters({
      isStatusActive: 'isStatusActive',
    }),
    computedCardStatus: {
      get: function () {
        let vm = this;
        try {
          let item = _.find(this.value.triggers, function (itm) {
            return itm.statusId === vm.value?.estimatesBooking?.scheduling?.nonAttendanceCardStatusId;
          });
          return item;
        } catch (e) {
          return {};
        }
      },
      set: function (item) {
        this.value.estimatesBooking.scheduling.nonAttendanceCardStatusId = item ? item.statusId : null;
      },
    },
    computedOnSiteCardStatus: {
      get: function () {
        let vm = this;
        try {
          let item = _.find(this.value.triggers, function (itm) {
            return itm.statusId === vm.value?.estimatesBooking?.scheduling?.onSiteCardStatusId;
          });
          return item;
        } catch (e) {
          return {};
        }
      },
      set: function (item) {
        this.value.estimatesBooking.scheduling.onSiteCardStatusId = item ? item.statusId : null;
      },
    }
  }
}
</script>

<style scoped>
.bx-trash-reasons-item{
  background: url(data:image/svg+xml;base64,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) no-repeat center left !important;
  border: none;
  width: 36px;
  height: 20px;
  cursor: pointer;
}

.estimage-line {
  width: 100%;
  height: 10px;
  right: 0;
  display: block;
  background: #e3e4e7;
}

.description-text {
  padding-top: 10px;
  color: rgba(0, 0, 0, 0.5);
}
.description-header {
  padding: 15px 15px 0px 15px;
}

</style>
